import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import clsx from 'clsx';
import KButton from '../KButtons/index.js';

var ConfirmationDialog = function ConfirmationDialog(_a) {
    var open = _a.open, title = _a.title, okLabel = _a.okLabel, _b = _a.okVariant, okVariant = _b === void 0 ? "contained" : _b, cancelLabel = _a.cancelLabel, _c = _a.cancelVariant, cancelVariant = _c === void 0 ? "contained" : _c, onClose = _a.onClose, className = _a.className, id = _a.id, _d = _a.testId, testId = _d === void 0 ? "ConfirmationDialog" : _d, customButton = _a.customButton, rest = __rest(_a, ["open", "title", "okLabel", "okVariant", "cancelLabel", "cancelVariant", "onClose", "className", "id", "testId", "customButton"]);
    var handleCancel = function () {
        onClose(false);
    };
    var handleOk = function () {
        onClose(true);
    };
    var Button = (customButton && customButton) || KButton;
    return (React__default.createElement(Dialog, __assign({}, rest, { className: clsx("ConfirmationDialog", className), disableEscapeKeyDown: true, maxWidth: "xs", "aria-labelledby": title ? "confirmation-dialog-title" : undefined, open: open, id: id, "data-testid": testId }),
        title && React__default.createElement(DialogTitle, { id: "confirmation-dialog-title" }, title),
        React__default.createElement(DialogContent, { dividers: true }, rest.children),
        React__default.createElement(DialogActions, null,
            React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Button, { variant: cancelVariant, onClick: handleCancel }, cancelLabel),
                React__default.createElement(Button, { variant: okVariant, onClick: handleOk, color: "primary" }, okLabel)))));
};

export { ConfirmationDialog as default };
//# sourceMappingURL=index.js.map
